export default __webpack_public_path__ + "static/media/invoice.c49f04c0.svg";